import CrudCustom from '../../../libs/custom/CrudCustom';

let AkunJenisService = new CrudCustom('/akun-jenis');
export default AkunJenisService;
